export const PROJECT_NAME = 'Sobha Skyparks Dubai'

export const EMAIL_JS_PUBLIC_KEY = "-SU1cSsz3-T2DV9yD"

export const EMAIL_JS_TEMPLATE_ID = "template_jsl0rss"

export const  EMAIL_JS_SERVICE_ID = "default_service"